/** Guest counts the public quote covers; larger weddings are handled personally */
export const QUOTE_MIN_GUESTS = 4;
export const QUOTE_MAX_GUESTS = 100;
/** Hours in the house on the weekend plan (1:00 p. m. to noon the next day) */
export const WEEKEND_PLAN_HOURS = 23;
/**
 * The included night, worded the same everywhere: the hours lead, the lodging capacity is the detail.
 * `people` is the house's lodging capacity (lodging_base_guests); 0 leaves it out.
 */
export const includedStayLabel = (people) => `${WEEKEND_PLAN_HOURS} horas en la casa · hospedaje incluido${people ? ` para ${people} personas` : ''}`;
